import Autocomplete from '@mui/material/Autocomplete';
import * as React from 'react';
import type { InputComponentProps } from '../../design-system';
import { SearchWrapper } from '../SearchWrapper';
import { type AutocompleteContents, renderAutocompleteInput } from './SimpleAutocomplete';

const vendorOptions = [
  { label: 'Evnex', value: 'evnex' },
  { label: 'Other', value: 'other' },
];

export const VendorInput: React.FC<InputComponentProps<string>> = ({
  value,
  name,
  onBlur,
  onChange,
  disabled,
  error,
  helperText,
}: InputComponentProps) => (
  <SearchWrapper>
    <Autocomplete
      disableClearable
      options={vendorOptions}
      getOptionLabel={(option) => option.label}
      value={vendorOptions.find(({ value: key }) => key === value)}
      renderInput={renderAutocompleteInput(disabled, error, helperText)}
      disabled={disabled}
      onBlur={onBlur}
      onChange={(_, vendor: AutocompleteContents<string>) => {
        // Note: this also blocks the user from manually clearing the field
        if (vendor?.value) {
          onChange(name)(vendor.value);
        }
      }}
      style={{ width: '100%' }}
    />
  </SearchWrapper>
);
